// <template>
// 	<div>
// 		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
// 			destroy-on-close>
// 			<template #default>
// 				<vxe-grid ref="orderdetail" v-if="list_gridOptions" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
// 			</template>
// 			<template #footer>
// 				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
// 			</template>
// 		</vxe-modal>
// 		<statistics :data="orderdata" ref="statistics" />
// 		<edit-index :row="currentrow" ref="editIndex" @success="submit" />
// 	</div>
// </template>
// <style scoped>

// </style>

import store from '@/store/store.js';
import router from '@_system/router/index.js'
export default {
	props: {
		penetrate: {
			type: Boolean,
			default: () => {
				return false
			}
		},
		penetrateModule: {
			type: Object,
			default: () => {
				return null
			}
		},
		penetrateComponent: {
			type: Object,
			default: () => {
				return null
			}
		},
	},
	data() {
		return {
			device:window.systemMethods.device(),
			penetrateComponentConfig: null,
			windowType:'window'
		}
	},
	created() {

	},
	methods: {
		preview() {
	
			let penetrateField = ['code']
			let prefixName = ''
			let field = ''
			let name = this.sourceModuleName
			if (this.row) {
				field = this.column.field
			} else {
				field = this.formCreateInject.field
			}
			
			for (let i = 0; i < penetrateField.length; i++) {
				let reg = new RegExp(penetrateField[i] + '$')
				if (reg.test(penetrateField[i])) {
					prefixName = field.slice(0, -penetrateField[i].length)
					break
				}
			}
			if (this.penetrateModule) {
				for (let i in this.penetrateModule) {
					let reg = new RegExp(i)
					if (reg.test(this.value)) {
						name = this.penetrateModule[i]
						break
					}
				}
			}
			if (this.penetrate) {
				let query = {
					name: name,
					controlltype: 3,
				}
				if (this.row) {
					query.id = this.row[prefixName + 'id']
					query.windowName = this.column.title + '（' + this.row[this.column.field] + '）'
				} else {
					query.id = this.formCreateInject.api.getValue(prefixName + 'id')
					query.windowName = this.formCreateInject.rule.title + '（' + this.value + '）'

				}
				if (field === 'relationflowtitle') {
					query.id = this.row.relationflowdataid
					query.name = this.row.relationflowformname.replace(/^c_/, '')
					query.windowName = this.row.relationflowtitle
				}
		
				if (query.id) {
					let penetrateMap = ''
					if (this.penetrateComponent) {
						for (let i in this.penetrateComponent) {
							let reg = new RegExp(i)
							if (reg.test(this.value)) {
								penetrateMap = this.penetrateComponent[i]
								break
							}
						}
					}		
					if (penetrateMap) {
						if (this.device != 'pc') {
							import(`@/${store.store.state.penetrateMap[penetrateMap]}`).then((res) => {
								this.penetrateComponentConfig = {
									component: res.default,
									props: {
										id: query.id,
										title: query.windowName,
										key: Math.random()
									}
								}
								this.$nextTick(() => {
									this.$refs.componentRef.modalShow()
								})
							})
						} else {
							
							let res = router.resolve({
								name: 'penetrate',
								query: {
									name: penetrateMap,
									title: query.windowName,
									id: query.id
								}
							})
							let win = window.open(res.href, query.id + "penetrate",
								"toolbar=no,width=1600,height=900,resizable=no")							
							win.onload = () => {
								console.log(query.id + '_penetrate open')
							}
						}
					} else {		
						if (this.device != 'pc') {
							let res = router.resolve({
								path: '/preview',
								query: query
							})
							router.push(res.href.replace(/#/g, ''))
						} else {
							if (this.windowType == 'window') {
								let res = router.resolve({
									name: 'preview',
									query: query
								})
								let win = window.open(res.href, query.name + 'preview',
									store.store.state.system.windowConfig)
								win.location.reload(true)
							} else {
								this.formModule = query
								this.formwindowShow = true
							}
						}
					}
				}
			}
		}
	}
}